"use client";

import Link from "next/link";

import Heading from "~/componentsDS/Typography/Heading";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import { cn } from "~/lib/utils";
import { ArrowRightIcon } from "@phosphor-icons/react/ssr";
import { useTrackEvent } from "~/hooks/useTrackEvent";
import { GTM_EVENT_NAMES } from "~/constants/gtmEvents";
import TextWithRegisteredMark from "~/componentsDS/TextWithRegisteredMark";

type SymptomRecommendationCardProps = {
    title: string;
    productName: string;
    description: string;
    className: string;
    link: string;
};

const SymptomRecommendationCard = ({ title, productName, description, className, link }: SymptomRecommendationCardProps) => {
    const sendEvent = useTrackEvent();

    const handleClick = () => {
        sendEvent({
            event: "user_interaction",
            value: {
                event_name: GTM_EVENT_NAMES.HP_INTERACTION,
                widget: "treatments_carousell",
                meta_data: {
                    click_text: title,
                    product_name: productName,
                },
            },
        }, link);
    };

    return (
        <Link
            href={link}
            onClick={handleClick}
            className={cn("group/src block p-5 md:p-6 w-full h-[110px] md:h-[140px] rounded-2xl overflow-hidden text-pureWhite", className)}
        >
            <Heading as="span" size="sm" className="mb-1">{title}</Heading>
            <Paragraph size="md" sizes={{md: "lg"}} weight="500" className="relative inline-block md:opacity-0 md:group-hover/src:opacity-100 transition-opacity duration-300">
                <span className="inline-block pt-[2px]">
                    <TextWithRegisteredMark text={description} />
                </span>
                <ArrowRightIcon width={20} height={20} className="absolute -right-2 top-1/2 -translate-y-1/2 translate-x-full" />
            </Paragraph>
        </Link>
    )
};

export default SymptomRecommendationCard;
